<template>
  <div>
    <div class="row">
      <div class="col-6">
        <div class="mx-4 d-flex flex-column">
          <div>
            <label class="me-3" for="color">背景色</label>
            <el-color-picker color-format="rgb" v-model="bgColor" />
          </div>
          <div>
            <h5 class="py-3">選擇圖片</h5>
            <el-select v-model="imageFileName" class="m-2" placeholder="Select" id="modeVertical">
              <el-option v-for="item in bgImagesByRain3D" :key="item.value" :label="item.label"
                         :value="item.value" />
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <button type="button" class="btn btn-primary mx-2" @click.stop="handleSubmit">確認</button>
        <button type="button" class="btn btn-secondary mx-2" @click.stop="handleInit">清空</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import CustomTextInput from '@/components/controllerMode/comp/TextInputComp.vue'
import WaterMarkImage from "@/components/controllerMode/comp/WaterMarkImageComp.vue";

import defaultValue from "@/utils/defaultValue"
import ColorTool from "@/utils/colorTool"
import freeImg from "@/utils/freeImg";

const {
  bgImagesByRain3D,
  watermarkImages
} = freeImg()

const {getRgbFilterString} =  ColorTool()

const {
  modeVertical,
  SensorVertical,
  showTextsList,
  textBoxPositionVertical,
  textBoxPositionHorizontal,
  textAlignments,
  fontFamilyVertical
} = defaultValue()
const emit = defineEmits(['getTempControlData'])
const props = defineProps(['effectName'])
const tempControlData = reactive({
  Theme: {},
  Text: {},
  Watermark: {}
})

const bgColor = ref('rgb(0,0,0)')


const limitCheckbox = () => {
  let maxNum = 4
  if (controllerSelected.value.length > maxNum) controllerSelected.value.splice(0, 1)
}


// Sensor
const Sensor = ref('CPULoad')
// 動態/靜態
const IsDynamicMode = ref('static')


const imageFileName = ref('')

function handleSubmit () {
  let BackgroundColor = []
  // 背景色
  if (bgColor.value.indexOf('rgb(') >= 0) BackgroundColor = getRgbFilterString(bgColor.value)

  Object.assign(tempControlData.Theme, {
    Effect: props.effectName,
    IsDynamicMode: false,
    Colors: [],
    BackgroundColor: BackgroundColor,
    HasBackgroundImage: imageFileName.value !== null && imageFileName.value !== '',
    BackgroundImage: imageFileName.value
  })

  Object.assign(tempControlData.Text, {
    Type: 'None'
  })

  Object.assign(tempControlData.Watermark, {
    "HasImage": false,
    "Image": 0
  })

  emit('getTempControlData', tempControlData)

}

function handleInit () {

}

</script>
